export class VideoPlayer {
  constructor({ el, playButton }) {
    this.DOM = { el };
    this.DOM.bg = this.DOM.el.querySelector('.video-player__bg');
    this.DOM.playButton = playButton;
    this.DOM.video = this.DOM.el.querySelector('video');
    this.bindEvents();
  }
  bindEvents() {
    this.DOM.playButton.addEventListener('click', e => {
      e.preventDefault();
      this.showPlayer();
    });
    this.DOM.bg.addEventListener('click', () => {
      this.hidePlayer();
    });
  }
  showPlayer() {
    this.DOM.el.classList.add('active');
    document.body.classList.add('no-scroll');
    this.playVideo();
  }
  hidePlayer() {
    this.pauseVideo();
    this.DOM.el.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }
  playVideo() {
    this.DOM.video.play();
  }
  pauseVideo() {
    this.DOM.video.pause();
  }
}
